import { writable } from "svelte/store";
import type { Writable } from "svelte/store";
import type { InjectionKey } from "@utils/svelte-typed-context";
import { setContext, getContext } from "@utils/svelte-typed-context";

export const key: InjectionKey<CtxState> = Symbol("nodeEditionContext");

/**
 * ctx setter
 */
type CtxState = {
  editMode: Writable<Boolean>;
  editSupportingMode: Writable<Boolean>;
  editPropertiesMode: Writable<Boolean>;
  editComment: Writable<Boolean>;
  editOn: () => void;
  editOff: () => void;
  setEditComment: (value: boolean) => void;
  setEditSupportingMode: (value: boolean) => void;
  setEditPropertiesMode: (value: boolean) => void;
};

let editMode: Writable<Boolean> = writable(false);
let editComment: Writable<Boolean> = writable(false);
let editSupportingMode: Writable<Boolean> = writable(false);
let editPropertiesMode: Writable<Boolean> = writable(false);
const editOff = () => editMode.set(false);
const editOn = () => editMode.set(true);
const setEditComment = (value: boolean) => editComment.set(value);
const setEditSupportingMode = (value: boolean) => editSupportingMode.set(value);
const setEditPropertiesMode = (value: boolean) => editPropertiesMode.set(value);

export const setCtx = () =>
  setContext(key, {
    editMode: editMode,
    editSupportingMode: editSupportingMode,
    editOff: editOff,
    editOn: editOn,
    editComment,
    editPropertiesMode: editPropertiesMode,
    setEditComment,
    setEditSupportingMode,
    setEditPropertiesMode,
  });

export const getCtx = () => getContext(key);
